document.addEventListener("DOMContentLoaded", function () {
  var detailsContainer = document.querySelector("details.offer-widget-container");
  var drawerBackground = document.querySelector(".drawer-background");
  var offerWrap = document.querySelector(".offer-widget");
  var splitList = document.querySelector(".split-list");

  function toggleActive() {
    drawerBackground.classList.toggle("active");
    offerWrap.classList.toggle("active");
    if (offerWrap.classList.contains("active")) {
      offerWrap.addEventListener("wheel", preventParentScroll);
      document.body.style.overflow = 'hidden'; 
    } else {
      offerWrap.removeEventListener("wheel", preventParentScroll);
      document.body.style.overflow = ''; 
    }
  }

  function closeOffer() {
    drawerBackground.classList.remove("active");
    offerWrap.classList.remove("active");
    offerWrap.removeEventListener("wheel", preventParentScroll);
    document.body.style.overflow = ''; 
  }

  detailsContainer.addEventListener("click", toggleActive);
  drawerBackground.addEventListener("click", closeOffer);
  document.querySelector(".offer-header-close-icon").addEventListener("click", closeOffer);

  function preventParentScroll(event) {
    var target = event.target;
    if (!target.closest(".split-list")) {
      event.preventDefault();
    }
  }
});